var map = {
	"./hp_quiz/favicon": 2,
	"./hp_quiz/favicon.png": 2,
	"./hp_quiz/logo": 0,
	"./hp_quiz/logo.png": 0,
	"./hp_quiz/social_windows": 3,
	"./hp_quiz/social_windows.svg": 3,
	"./loading_animation": 4,
	"./loading_animation.gif": 4,
	"./no_user_image": 5,
	"./no_user_image.png": 5,
	"./orni_quiz/favicon": 6,
	"./orni_quiz/favicon.png": 6,
	"./orni_quiz/login_howto": 7,
	"./orni_quiz/login_howto.png": 7,
	"./orni_quiz/logo": 8,
	"./orni_quiz/logo.png": 8,
	"./orni_quiz/logo_small": 1,
	"./orni_quiz/logo_small.png": 1,
	"./orni_quiz/start_quiz": 9,
	"./orni_quiz/start_quiz.png": 9,
	"./psych_quiz/favicon": 10,
	"./psych_quiz/favicon.png": 10,
	"./psych_quiz/logo": 11,
	"./psych_quiz/logo.png": 11,
	"./psych_quiz/social_windows": 12,
	"./psych_quiz/social_windows.svg": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;